import React from 'react';
import arrayShuffle from 'array-shuffle';

const Latex = require('react-latex');

export default class SceltaMultipla extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            domanda: props.domanda, 
            risposte: arrayShuffle(props.risposte), 
            risposta: undefined,
            allegato: props.allegato, 
        };
    }

    getRisposta() {
        
        if (this.state.risposta)
            return this.state.risposta;
        else
            return 0;
    }

    render() {

        return(
            <section className='question-container'>
                <h5>{this.state.domanda}</h5>
                { this.state.allegato && (
                    <section style={{ marginTop: 20 }}>
                        { this.state.allegato.includes('math:///') ? (
                            <Latex displayMode={true}>{'$$' + this.state.allegato.replace('math:///', '') + '$$'}</Latex>
                        ) : (
                            <img alt="Allegato" src={this.state.allegato.replace('img:///', '')} style={{ width: '40%', height: 'auto', marginLeft: '30%' }} />
                        )}
                    </section>
                )}
                <p style={{ color: '#818181', marginTop: 30, fontWeight: 'bold' }}>Clicca sulla risposta che ritieni corretta.</p>
                <div className='answer-container' style={{ flexDirection: 'column', paddingTop: 30 }}>
                    { this.state.risposte.map((risposta) => {

                        return(
                            <section key={parseInt(risposta.id)} className='answer answer-selectable' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', paddingLeft: 20, paddingRight: 20, paddingTop: 10, paddingBottom: 10 }} onClick={() => this.setState({ risposta: parseInt(risposta.id)})}>
                                { this.state.risposta === parseInt(risposta.id) && <img src={ require('../../images/tick.png') } style={{ width: 20, height: 20, cursor: 'pointer' }} /> }
                                <span style={{ marginLeft: this.state.risposta === parseInt(risposta.id) ? 10 : 30 }}>{risposta.risposta}</span>
                            </section>
                        );
                    })}
                </div>
            </section>
        );
    }
}